export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v1';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  SESSION_ID: 'session_id',
  OTP_PHONE: 'otp_phone',
  AUTH_INTENT: 'auth_intent',
  GUIDE_DASHBOARD_TOUR_SEEN: 'guide_dashboard_tour_seen',
  GUIDE_CAMPAIGN_DISMISSED: 'guide_campaign_dismissed',
  GUIDE_CAMPAIGN_SESSION_SHOWN: 'guide_campaign_session_shown',
  GUIDE_FLOW_ENTERED_SESSION: 'guide_flow_entered_session',
};

/** @deprecated Import from '@/features/onboarding/constants' */
export { GUIDE_SPECIALIZATIONS, LANGUAGES, INDIA_STATES } from '@/features/onboarding/constants';
